/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateListingInterface } from './createListingTypes';
import style from './createListing.module.scss';
import '../../constants/_global.scss';
import UploadComponent from '../../UI/uploadComponent/uploadComponent';
import {
  INPUT_GLOBAL_TYPES,
  LISTING_NAMES,
  ListingDataInterface,
  radioInputText,
} from '../../constants/constants';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import DropDownMenu from '../../UI/dropDownMenu/dropDownMenu';
import RadioInput from '../../UI/radioInput/radioInput';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import Textarea from '../../UI/textarea/textarea';
import { useDispatch, useSelector } from '../../index';
import { createListing, updateListing } from '../../service/ListingData';

const defaultData = {
  id: 0,
  img1: null,
  img2: null,
  img3: null,
  name: '',
  category: 'Авто',
  condition: 'Новый',
  city: 'Москва',
  description: '',
  price: 0,
  owner: 0,
  isOwner: false,
  isFavorite: false,
  ownerUsername: '',
  ownerEmail: '',
};

const EditListing: React.FC<CreateListingInterface> = ({
  editData,
  category,
  city,
}) => {
  const navigate = useNavigate();
  const userId = useSelector((state) => state.userData.user.id);
  const { id } = useParams() as { id: string };
  const dispatch = useDispatch();
  const storeData = useSelector((state) => {
    const listingById = (l: ListingDataInterface) =>
      l.id.toString() === id;

    return (
      state.listingData.listings?.find(listingById) ||
      state.listingData.ownListings?.find(listingById) ||
      state.listingData.ownFavoriteListings?.find(listingById)
    );
  });
  const [formData, setFormData] = useState<ListingDataInterface>(
    editData || defaultData
  );
  useEffect(() => {
    if (storeData && storeData.owner === userId) {
      setFormData(storeData);
    } else {
      navigate('/create-lisiting');
    }
  }, [storeData, id]);
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 1350 }),
    isTabletOrMobile: useMediaQuery({ maxWidth: 1100 }),
    isMobile: useMediaQuery({ maxWidth: 500 }),
  };
  const isOwner = storeData && storeData.owner === userId;
  const title = isOwner ? 'Редактировать объявление' : 'Новое объявление';
  const buttonText = isOwner ? 'Сохранить изменения' : 'Опубликовать';
  const desktopButtonWidth = isOwner ? 235 : 174;
  const titleStyle = resolution.isTabletOrMobile ? 'h1Mobile' : 'hi';

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = event.target;
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFormData((prevState) => ({
        ...prevState,
        [name]: file,
      }));
    }
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handelSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const offerId = formData.id;
    const data = new FormData();
    data.append('name', formData.name);
    data.append('category', formData.category);
    data.append('condition', formData.condition);
    data.append('city', formData.city);
    data.append('description', formData.description);
    data.append('price', formData.price.toString());

    if (formData.img1 === null) {
      data.append('img1', 'null');
    } else if (typeof formData.img1 === 'string') {
      data.append('img1', formData.img1);
    } else if (formData.img1 instanceof File) {
      data.append('images', formData.img1);
    }

    if (formData.img2 === null) {
      data.append('img2', 'null');
    } else if (typeof formData.img2 === 'string') {
      data.append('img2', formData.img2);
    } else if (formData.img2 instanceof File) {
      data.append('images', formData.img2);
    }

    if (formData.img3 === null) {
      data.append('img3', 'null');
    } else if (typeof formData.img3 === 'string') {
      data.append('img3', formData.img3);
    } else if (formData.img3 instanceof File) {
      data.append('images', formData.img3);
    }

    const resultAction = await dispatch(
      updateListing({ offerId, formData: data })
    );
    if (updateListing.fulfilled.match(resultAction)) {
      navigate('/');
      console.log(data);
      console.log(formData);
    }
  };

  const handleDelete = (name: string) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: null,
    }));
    console.log(formData);
  };

  return (
    <div
      className={resolution.isTabletOrMobile ? style.shellMobile : style.shell}
    >
      <h1 className={`${titleStyle} ${style.title}`}>{title}</h1>
      <form
        className={
          resolution.isTabletOrMobile ? style.shellMobile : style.shell
        }
      >
        <div
          className={
            resolution.isTabletOrMobile ? style.inputColumn : style.inputRow
          }
        >
          <UploadComponent
            photo={typeof formData.img1 === 'string' ? formData.img1 : null}
            name={LISTING_NAMES.IMG1}
            onChange={handleFileChange}
            width={resolution.isTabletOrMobile ? 700 : 424}
            onDelete={handleDelete}
          />
          <UploadComponent
            photo={typeof formData.img2 === 'string' ? formData.img2 : null}
            name={LISTING_NAMES.IMG2}
            onChange={handleFileChange}
            width={resolution.isTabletOrMobile ? 700 : 424}
            onDelete={handleDelete}
          />
          <UploadComponent
            photo={typeof formData.img3 === 'string' ? formData.img3 : null}
            name={LISTING_NAMES.IMG3}
            onChange={handleFileChange}
            width={resolution.isTabletOrMobile ? 700 : 424}
            onDelete={handleDelete}
          />
        </div>
        <div
          className={
            resolution.isTabletOrMobile ? style.inputRowMobile : style.inputRow
          }
        >
          <Input
            placeholder="Название"
            ver={INPUT_TYPE.REGULAR}
            name={LISTING_NAMES.NAME}
            onChange={handleChange}
            errStatus={false}
            inputValue={formData.name}
            customWidth={984}
            customMargin={0}
          />
          <DropDownMenu
            options={category}
            name={LISTING_NAMES.CATEGORY}
            onChange={handleChange}
            customWidth={resolution.isTabletOrMobile ? 984 : 312}
            isMobile={resolution.isTabletOrMobile}
          />
        </div>
        <fieldset
          className={
            resolution.isTabletOrMobile
              ? style.inputRadioMobile
              : style.inputRadio
          }
        >
          <h3 className={`spanGlobal ${style.span}`}>Состояние товара:</h3>
          <div className={style.inputRadio}>
            <RadioInput
              name={LISTING_NAMES.CONDITION}
              value={radioInputText.valueNew}
              checked={formData.condition === radioInputText.valueNew}
              onChange={handleRadioChange}
            />
            <RadioInput
              name={LISTING_NAMES.CONDITION}
              value={radioInputText.valueUsed}
              onChange={handleRadioChange}
              checked={formData.condition === radioInputText.valueUsed}
            />
          </div>
        </fieldset>
        <DropDownMenu
          options={city}
          name={LISTING_NAMES.CITY}
          onChange={handleChange}
          customWidth={760}
          isMobile={resolution.isTabletOrMobile}
        />
        <Textarea
          placeholder="Описание товара"
          errStatus={false}
          name={LISTING_NAMES.DESCRIPTION}
          onChange={handleChange}
          inputValue={formData.description}
          customWidth={760}
          customHeight={175}
          customMargin={0}
        />
        <Input
          placeholder="Стоимость"
          ver={INPUT_TYPE.REGULAR}
          accept={INPUT_GLOBAL_TYPES.Number}
          errStatus={false}
          name={LISTING_NAMES.PRICE}
          onChange={handleChange}
          inputValue={formData.price}
          customWidth={resolution.isTabletOrMobile ? 700 : 312}
          customMargin={0}
        />
        <Button
          ver={BUTTON_VER.primary}
          type={BUTTON_TYPE.Submit}
          text={buttonText}
          customWidth={resolution.isTabletOrMobile ? 700 : desktopButtonWidth}
          onClick={(e) => handelSubmit(e)}
        />
      </form>
    </div>
  );
};

export default EditListing;
